module.exports = __webpack_public_path__ + "static/artist-marketing-the-results-7ccf32b4205db6fb82086f55b368317f.png";